var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-tab-item",class:{
    'header-tab-item_active': _vm.active
  },on:{"click":function($event){return _vm.$emit('activate')}}},[_vm._v("\n  "+_vm._s(_vm.tabName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }